// @ts-nocheck
/**
 * Drops menu entries the user may not open:
 * - `superAdminOnly: true`: shown to role 100 only; with `teamLeadersToo: true` also to anyone who
 *   leads a team (the server scopes what they see, e.g. Mail Monitor: their team's mailboxes).
 * - `screenKey: '<screen>'`: shown when the Super Admin's Screen Access rules give the role VIEW.
 *   A screen whose access is still loading, or failed to load, stays visible; the screen itself
 *   checks again and shows its own "no access" state.
 *
 * Returns categories and sub-categories without the dropped items, and drops any that end up empty.
 */
export function filterMenuForAccess(menu, { isSuperAdmin, canViewScreen, isTeamLeader = false }) {
  const keep = (item) => {
    if (item.superAdminOnly && !isSuperAdmin && !(item.teamLeadersToo && isTeamLeader)) return false;
    if (item.screenKey && canViewScreen(item.screenKey) === false) return false;
    return true;
  };

  const filterGroup = (group) => {
    const items = group.items?.filter(keep);
    const subCategories = group.subCategories?.map(filterGroup).filter(Boolean);
    const hasItems = (items?.length ?? 0) > 0 || (subCategories?.length ?? 0) > 0;
    if (!hasItems) return null;
    return {
      ...group,
      ...(group.items ? { items } : {}),
      ...(group.subCategories ? { subCategories } : {}),
    };
  };

  return menu.map(filterGroup).filter(Boolean);
}
